import { render, staticRenderFns } from "./ClientNoticesCrud.vue?vue&type=template&id=34c304d9&"
import script from "./ClientNoticesCrud.vue?vue&type=script&lang=js&"
export * from "./ClientNoticesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports